import styled, { css } from 'styled-components';
import SVGIcon from '../../../assets/images/svg/SVGIcon';

const PageLoading = styled.span<{ isInline?: boolean }>`
  display: flex;
  ${({ isInline }) =>
    !isInline &&
    css`
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    `}
`;

interface Props {
  size?: number;
  // In the normal flow instead of centered over the parent.
  isInline?: boolean;
}

function AppLoading({ size = 36, isInline }: Props) {
  return (
    <PageLoading isInline={isInline}>
      <SVGIcon name={'app-loading'} width={`${size}`} height={`${size}`} viewBox='0 0 38 38' stroke='var(--text-primary)' />
    </PageLoading>
  );
}

export default AppLoading;
